import React, { Component, Fragment } from "react";
import withAssets from "../../../../components/hoc/withAssets";
import { withTranslation } from "react-i18next";
import {
  Controls,
  Form, FormHeader, GelContentColumn,
  GelContentContainer, GelContentRow,
  Notice, TextfieldElement, Button, Role, FormTabs, FormTab, TextareaElement
} from 'cw-styleguide-react';
import { route } from "../../../../routes";
import {
  OPERATION_TRANSLATE_DRAFT,
  OPERATION_TRANSLATE_AMENDED,
  STATUS_AWAITING_TRANSLATION,
  STATUS_AWAITING_AMENDMENTS,
  STATUS_PUBLISHED,
  LANGUAGE_EN,
  LANGUAGE_CY,
  TRANSLATOR_UNASSIGNED,
  TAB_COURSE_DETAILS,
  TAB_COURSE_SESSIONS,
  ROLE_TRANSLATOR_MANAGER,
} from "../../../../constants";
import ErrorNavigation from "../../../../components/ErrorNavigation";
import WysiwygElement from "../../../../components/WysiwygElement";

class CoursesTranslateDetailsForm extends Component {
  render() {
    const isWorkBasedLearningCourse = ['267040002', '267040003', '267040004'].includes(this.props.values.courseGroup?.type);

    return (
      <Form>
        <ErrorNavigation field={this.props.errorActiveField} handleClearActiveErrors={this.props.handleClearActiveErrors} />
        <FormHeader title={this.props.t('local:view.courses.' + this.props.operation + '.tabs.courseDetails.formHeader.title')}
          introduction={this.props.t('local:view.courses.' + this.props.operation + '.tabs.courseDetails.formHeader.introduction')} />
        <GelContentRow>
          <GelContentColumn md={6}><h3>{this.props.t('styleguide:languages.english')}</h3></GelContentColumn>
          <GelContentColumn md={6}><h3>{this.props.t('styleguide:languages.welsh')}</h3> </GelContentColumn>
        </GelContentRow>
        {/* Course Title */}
        {console.log('orig',this.props.originalValues)}
        {console.log('current',this.props.values)}
        {this.props.originalValues['title'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('title') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.title.label')}
                  id={'title_en'}
                  name={'title.en'}
                  value={this.props.values['title'][LANGUAGE_EN]}

                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['title_en']}
                  required={true}
                  onKeyPress={this.context.preventDefaultOnEnter}

                />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.title.label')}
                  id={'title_cy'}
                  name={'title.cy'}
                  value={this.props.values['title'][LANGUAGE_CY]}
                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['title_cy']}
                  onKeyPress={this.context.preventDefaultOnEnter}
                  required={true}

                  descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'title') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.title.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Abbreviated Title */}
        {this.props.originalValues['abbreviatedTitle'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('abbreviatedTitle') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.abbreviatedTitle.label')}
                  id={'abbreviatedTitle_en'}
                  name={'abbreviatedTitle.en'}
                  value={this.props.values['abbreviatedTitle'][LANGUAGE_EN]}

                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['abbreviatedTitle_en']}
                  onKeyPress={this.context.preventDefaultOnEnter} />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.abbreviatedTitle.label')}
                  id={'abbreviatedTitle_cy'}
                  name={'abbreviatedTitle.cy'}
                  value={this.props.values['abbreviatedTitle'][LANGUAGE_CY]}
                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['abbreviatedTitle_cy']}
                  onKeyPress={this.context.preventDefaultOnEnter}

                  descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'abbreviatedTitle') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.abbreviatedTitle.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Summary */}
        {!isWorkBasedLearningCourse && this.props.originalValues['summary'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('summary') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'summary.en'}
                  id={'summary_en'}
                  label={this.props.t('local:view.courses.translateDraft.field.summary.label')}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('summary'))}
                  value={this.props.values['summary'][LANGUAGE_EN]}
                  errors={this.props.formErrors['summary_en']}
                  onChange={(e) => this.props.handleSetFormValue('summary.en', e.data.get())}
                  required={true}
                />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'summary.cy'}
                  id={'summary_cy'}
                  label={this.props.t('local:view.courses.translateDraft.field.summary.label')}
                  value={this.props.values['summary'][LANGUAGE_CY]}
                  errors={this.props.formErrors['summary_cy']}
                  onChange={(e) => this.props.handleSetFormValue('summary.cy', e.data.get())}
                  required={true}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('summary'))}
                  descriptionAfter={!isWorkBasedLearningCourse && <Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'summary') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.summary.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Course Content */}
        {this.props.originalValues['content'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('content') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'content.en'}
                  id={'content_en'}
                  label={this.props.t('local:view.courses.translateDraft.field.content.label')}

                  value={this.props.values['content'][LANGUAGE_EN]}
                  errors={this.props.formErrors['content_en']}
                  onChange={(e) => this.props.handleSetFormValue('content.en', e.data.get())}
                  required={true} />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'content.cy'}
                  id={'content_cy'}
                  label={this.props.t('local:view.courses.translateDraft.field.content.label')}
                  value={this.props.values['content'][LANGUAGE_CY]}
                  errors={this.props.formErrors['content_cy']}
                  onChange={(e) => this.props.handleSetFormValue('content.cy', e.data.get())}
                  required={true}

                  descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'content') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.content.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Duration */}
        {!isWorkBasedLearningCourse && this.props.originalValues['duration'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('duration') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.duration.label')}
                  id={'duration_en'}
                  name={'duration.en'}
                  value={this.props.values['duration'][LANGUAGE_EN]}
                                 // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('duration'))}
                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['duration_en']}
                  onKeyPress={this.context.preventDefaultOnEnter} />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.duration.label')}
                  id={'duration_cy'}
                  name={'duration.cy'}
                  value={this.props.values['duration'][LANGUAGE_CY]}
                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['duration_cy']}
                  onKeyPress={this.context.preventDefaultOnEnter}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('duration'))}
                  descriptionAfter={!isWorkBasedLearningCourse && <Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'duration') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.duration.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Entry Requirements */}
        {!isWorkBasedLearningCourse && this.props.originalValues['entry'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('entry') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'entry.en'}
                  id={'entry_en'}
                  label={this.props.t('local:view.courses.translateDraft.field.entry.label')}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('entry'))}
                  value={this.props.values['entry'][LANGUAGE_EN]}
                  errors={this.props.formErrors['entry_en']}
                  onChange={(e) => this.props.handleSetFormValue('entry.en', e.data.get())}
                  required={true} />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'entry.cy'}
                  id={'entry_cy'}
                  label={this.props.t('local:view.courses.translateDraft.field.entry.label')}
                  value={this.props.values['entry'][LANGUAGE_CY]}
                  errors={this.props.formErrors['entry_cy']}
                  onChange={(e) => this.props.handleSetFormValue('entry.cy', e.data.get())}
                  required={true}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('entry'))}
                  descriptionAfter={!isWorkBasedLearningCourse && <Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'entry') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.entry.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Additional Details */}
        {!isWorkBasedLearningCourse && this.props.originalValues['additionalDetails'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('additionalDetails') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'additionalDetails.en'}
                  id={'additionalDetails_en'}
                  label={this.props.t('local:view.courses.translateDraft.field.additionalDetails.label')}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('additionalDetails'))}
                  value={this.props.values['additionalDetails'][LANGUAGE_EN]}
                  errors={this.props.formErrors['additionalDetails_en']}
                  onChange={(e) => this.props.handleSetFormValue('additionalDetails.en', e.data.get())}
                />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'additionalDetails.cy'}
                  id={'additionalDetails_cy'}
                  label={this.props.t('local:view.courses.translateDraft.field.additionalDetails.label')}
                  value={this.props.values['additionalDetails'][LANGUAGE_CY]}
                  errors={this.props.formErrors['additionalDetails_cy']}
                  onChange={(e) => this.props.handleSetFormValue('additionalDetails.cy', e.data.get())}
                  // disabled={(this.props.operation === OPERATION_TRANSLATE_AMENDED && !this.props.translatableFields.includes('additionalDetails'))}
                  descriptionAfter={!isWorkBasedLearningCourse && <Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'additionalDetails') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.additionalDetails.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Enrolment */}
        {this.props.originalValues['enrolment'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('enrolment') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'enrolment.en'}
                  id={'enrolment_en'}
                  label={this.props.t('local:view.courses.translateDraft.field.enrolment.label')}

                  value={this.props.values['enrolment'][LANGUAGE_EN]}
                  errors={this.props.formErrors['enrolment_en']}
                  onChange={(e) => this.props.handleSetFormValue('enrolment.en', e.data.get())}
                />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <WysiwygElement
                  name={'enrolment.cy'}
                  id={'enrolment_cy'}
                  label={this.props.t('local:view.courses.translateDraft.field.enrolment.label')}
                  value={this.props.values['enrolment'][LANGUAGE_CY]}
                  errors={this.props.formErrors['enrolment_cy']}
                  onChange={(e) => this.props.handleSetFormValue('enrolment.cy', e.data.get())}


                  descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'enrolment') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.enrolment.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* Cost */}
        {this.props.originalValues['cost'][LANGUAGE_EN] &&
          <Fragment>
            {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('cost') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
            <GelContentRow>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.cost.label')}
                  id={'cost_en'}
                  name={'cost.en'}
                  value={this.props.values['cost'][LANGUAGE_EN]}

                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['cost_en']}
                  onKeyPress={this.context.preventDefaultOnEnter} />
              </GelContentColumn>
              <GelContentColumn md={6}>
                <TextareaElement size={'large'}
                  label={this.props.t('local:view.courses.translateDraft.field.cost.label')}
                  id={'cost_cy'}
                  name={'cost.cy'}
                  value={this.props.values['cost'][LANGUAGE_CY]}
                  onChange={this.props.handleChange}
                  errors={this.props.formErrors['cost_cy']}
                  onKeyPress={this.context.preventDefaultOnEnter}

                  descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'cost') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.cost.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                />
              </GelContentColumn>
            </GelContentRow>
          </Fragment>
        }

        {/* manualQualifications */}
        {this.props.originalValues.manualQualifications.length > 0 &&
          <Fragment>
            {this.props.values.manualQualifications.map((element, index) => {
              return <Fragment key={index}>
                <h4 className={"style--typography-style--branded-a"}>{this.props.t('local:view.courses.translateDraft.field.qualification.label')} {element.id}</h4>
                {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('manualQualifications.' + element.id + '.title') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextareaElement size={'large'}
                      label={this.props.t('local:view.courses.translateDraft.field.manualQualifications.label')}
                      id={'manualQualifications.' + element.id + '.title_en'}
                      name={'manualQualifications.' + index + '.title.en'}
                      value={this.props.values['manualQualifications'][index]['title'][LANGUAGE_EN]}

                      onChange={this.props.handleChange}
                      required={true}
                      errors={this.props.formErrors['manualQualifications.1.title_en']}
                      onKeyPress={this.context.preventDefaultOnEnter} />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextareaElement size={'large'}
                      label={this.props.t('local:view.courses.translateDraft.field.manualQualifications.label')}
                      id={'manualQualifications.' + element.id + '.title_cy'}
                      name={'manualQualifications.' + index + '.title.cy'}
                      value={this.props.values['manualQualifications'][index]['title'][LANGUAGE_CY]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      required={true}
                      errors={this.props.formErrors['manualQualifications.1.title_cy']}

                      descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'manualQualifications.' + index + '.title') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.manualQualifications.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            })}
          </Fragment>
        }

      </Form>
    )
  }
}

export default withAssets(withTranslation('local')(CoursesTranslateDetailsForm));
